import { configureStore } from '@reduxjs/toolkit'
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import profileReducer from './slices/profile'
import gameReducer from './slices/game'
import gameSessionReducer from './slices/gameSession'
import adminReducer from './slices/admin'
import adminDashboardReducer from './slices/adminDashboard'
import adminGameViewReducer from './slices/adminGameView'
import questionEditModalReducer from './slices/modals/questionEditModal'
import sectionOrderModalReducer from './slices/modals/sectionOrderModal'
import gameOrderModalReducer from './slices/modals/gameOrderModal'
import sectionEditModalReducer from './slices/modals/sectionEditModal'
import gameEditModalReducer from './slices/modals/gameEditModal'
import adminGameSessionReducer from './slices/adminGameSessions'
import themeModalReducer from './slices/modals/themeModal'
import eventModalReducer from './slices/modals/eventModal'
import adminListReducer from './slices/adminList'
import userModalReducer from "./slices/modals/userModal";
import adminUserViewReducer from "./slices/adminUserView";
import teamModalReducer from "./slices/modals/teamModal";
import adminSessionReducer from "./slices/adminSession";
import adminQuestionReducer from "./slices/adminQuestion";
import formModalReducer from "./slices/modals/formModal";
import previewOffCanvasReducer from "./slices/offCanvas/previewOffCanvas";
import linkModalReducer from "./slices/modals/linkModal";
import elementModalReducer from "./slices/modals/elementModal";
import collectionEditModalReducer from "./slices/modals/collectionEditModal";
import collectionElementModalReducer from "./slices/modals/collectionElementModal";
import sectionPdfModalReducer from "./slices/modals/sectionPdfModal";
import userImportModalReducer from "./slices/modals/userImportModal";
import statisticsReducer from "./slices/statistics";

export const createStore = () => {
    return configureStore({
        reducer: {
            profile: profileReducer,
            game: gameReducer,
            gameSession: gameSessionReducer,
            admin: adminReducer,
            adminDashboard: adminDashboardReducer,
            adminGameView: adminGameViewReducer,
            adminGameSession: adminGameSessionReducer,
            questionEditModal: questionEditModalReducer,
            sectionEditModal: sectionEditModalReducer,
            sectionOrderModal: sectionOrderModalReducer,
            gameOrderModal: gameOrderModalReducer,
            gameEditModal: gameEditModalReducer,
            themeModal: themeModalReducer,
            eventModal: eventModalReducer,
            adminList: adminListReducer,
            userModal: userModalReducer,
            adminUserView: adminUserViewReducer,
            teamModal: teamModalReducer,
            formModal: formModalReducer,
            adminSession: adminSessionReducer,
            adminQuestion: adminQuestionReducer,
            previewOffCanvas: previewOffCanvasReducer,
            linkModal: linkModalReducer,
            elementModal: elementModalReducer,
            collectionEditModal: collectionEditModalReducer,
            collectionElementModal: collectionElementModalReducer,
            sectionPdfModal: sectionPdfModalReducer,
            userImportModal: userImportModalReducer,
            statistics: statisticsReducer
        }
    });
}

export const store = createStore()
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export type RootState = ReturnType<typeof store.getState>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
